

















// vendor
import { defineComponent, computed, ref, watch } from "@vue/composition-api";
// project
import * as AssetAPI from "@/services/api/assets";
import { Asset, AssetVersion } from "@/psychlab/types/assets";
import { PreviewAssetForm } from "@/components.assets/preview-asset-form";
import { PreviewAssetGraph } from "@/components.assets/preview-asset-graph";
import { PreviewAssetCognitiveTest } from "@/components.assets/preview-asset-cognitivetest";
import { generateGUID } from "@/utils/guid";
import { DisplayJSON } from "@/components.generic/display-code";

export default defineComponent({

	emits:[
		"input"
	],
	props:{
		data:{
			type:Object,
			required:true,
		},
	},
	components:{
		"display-json":DisplayJSON,
	},
	setup(props){
		return {
			
		};
	}
});

